import { render, staticRenderFns } from "./TeamManagerVariableSalaryModal.vue?vue&type=template&id=70f9ce64&scoped=true&"
import script from "./TeamManagerVariableSalaryModal.vue?vue&type=script&lang=ts&"
export * from "./TeamManagerVariableSalaryModal.vue?vue&type=script&lang=ts&"
import style0 from "./TeamManagerVariableSalaryModal.vue?vue&type=style&index=0&id=70f9ce64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f9ce64",
  null
  
)

export default component.exports